export { createJBrowseTheme, ThemeProvider } from './deprecations';
export { default as JBrowseLinearGenomeView } from './JBrowseLinearGenomeView';
export { default as createModel } from './createModel';
export { default as createViewState } from './createViewState';
export { default as loadPlugins } from './loadPlugins';